/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as authIndexRouteImport } from './routes/(auth)/index'
import { Route as authWaitRouteImport } from './routes/(auth)/wait'
import { Route as authLoginCallbackRouteImport } from './routes/(auth)/login-callback'
import { Route as DashboardUsersIndexRouteImport } from './routes/dashboard/users/index'
import { Route as DashboardTenantsIndexRouteImport } from './routes/dashboard/tenants/index'
import { Route as DashboardPcmIndexRouteImport } from './routes/dashboard/pcm/index'
import { Route as DashboardPaymentsIndexRouteImport } from './routes/dashboard/payments/index'
import { Route as DashboardOrganizationsIndexRouteImport } from './routes/dashboard/organizations/index'
import { Route as DashboardConsentsIndexRouteImport } from './routes/dashboard/consents/index'
import { Route as DashboardClientsIndexRouteImport } from './routes/dashboard/clients/index'
import { Route as DashboardActivitiesIndexRouteImport } from './routes/dashboard/activities/index'
import { Route as DashboardTenantsNewIndexRouteImport } from './routes/dashboard/tenants/new/index'
import { Route as DashboardPaymentsTenantIdPaymentIdRouteImport } from './routes/dashboard/payments/$tenantId.$paymentId'
import { Route as DashboardConsentsTenantIdConsentIdRouteImport } from './routes/dashboard/consents/$tenantId.$consentId'
import { Route as DashboardClientsTenantIdClientIdRouteImport } from './routes/dashboard/clients/$tenantId.$clientId'
import { Route as DashboardTenantsTenantIdInternalCredentialsIndexRouteImport } from './routes/dashboard/tenants/$tenantId/internal-credentials/index'
import { Route as DashboardTenantsTenantIdFeatureFlagsIndexRouteImport } from './routes/dashboard/tenants/$tenantId/feature-flags/index'
import { Route as DashboardTenantsTenantIdsettingsPaymentSettingsRouteImport } from './routes/dashboard/tenants/$tenantId/(settings)/payment-settings'
import { Route as DashboardTenantsTenantIdsettingsMobileSettingsRouteImport } from './routes/dashboard/tenants/$tenantId/(settings)/mobile-settings'
import { Route as DashboardTenantsTenantIdsettingsGeneralSettingsRouteImport } from './routes/dashboard/tenants/$tenantId/(settings)/general-settings'
import { Route as DashboardTenantsTenantIdsettingsEnrollmentSettingsRouteImport } from './routes/dashboard/tenants/$tenantId/(settings)/enrollment-settings'
import { Route as DashboardTenantsTenantIdsettingsDataSettingsRouteImport } from './routes/dashboard/tenants/$tenantId/(settings)/data-settings'
import { Route as DashboardTenantsTenantIdsettingsAuthSettingsRouteImport } from './routes/dashboard/tenants/$tenantId/(settings)/auth-settings'

const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const authIndexRoute = authIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => authRouteRoute,
} as any)
const authWaitRoute = authWaitRouteImport.update({
  id: '/wait',
  path: '/wait',
  getParentRoute: () => authRouteRoute,
} as any)
const authLoginCallbackRoute = authLoginCallbackRouteImport.update({
  id: '/login-callback',
  path: '/login-callback',
  getParentRoute: () => authRouteRoute,
} as any)
const DashboardUsersIndexRoute = DashboardUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardTenantsIndexRoute = DashboardTenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPcmIndexRoute = DashboardPcmIndexRouteImport.update({
  id: '/pcm/',
  path: '/pcm/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardPaymentsIndexRoute = DashboardPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardOrganizationsIndexRoute =
  DashboardOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardConsentsIndexRoute = DashboardConsentsIndexRouteImport.update({
  id: '/consents/',
  path: '/consents/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardClientsIndexRoute = DashboardClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardActivitiesIndexRoute =
  DashboardActivitiesIndexRouteImport.update({
    id: '/activities/',
    path: '/activities/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantsNewIndexRoute =
  DashboardTenantsNewIndexRouteImport.update({
    id: '/tenants/new/',
    path: '/tenants/new/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPaymentsTenantIdPaymentIdRoute =
  DashboardPaymentsTenantIdPaymentIdRouteImport.update({
    id: '/payments/$tenantId/$paymentId',
    path: '/payments/$tenantId/$paymentId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardConsentsTenantIdConsentIdRoute =
  DashboardConsentsTenantIdConsentIdRouteImport.update({
    id: '/consents/$tenantId/$consentId',
    path: '/consents/$tenantId/$consentId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardClientsTenantIdClientIdRoute =
  DashboardClientsTenantIdClientIdRouteImport.update({
    id: '/clients/$tenantId/$clientId',
    path: '/clients/$tenantId/$clientId',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantsTenantIdInternalCredentialsIndexRoute =
  DashboardTenantsTenantIdInternalCredentialsIndexRouteImport.update({
    id: '/tenants/$tenantId/internal-credentials/',
    path: '/tenants/$tenantId/internal-credentials/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantsTenantIdFeatureFlagsIndexRoute =
  DashboardTenantsTenantIdFeatureFlagsIndexRouteImport.update({
    id: '/tenants/$tenantId/feature-flags/',
    path: '/tenants/$tenantId/feature-flags/',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantsTenantIdsettingsPaymentSettingsRoute =
  DashboardTenantsTenantIdsettingsPaymentSettingsRouteImport.update({
    id: '/tenants/$tenantId/(settings)/payment-settings',
    path: '/tenants/$tenantId/payment-settings',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantsTenantIdsettingsMobileSettingsRoute =
  DashboardTenantsTenantIdsettingsMobileSettingsRouteImport.update({
    id: '/tenants/$tenantId/(settings)/mobile-settings',
    path: '/tenants/$tenantId/mobile-settings',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantsTenantIdsettingsGeneralSettingsRoute =
  DashboardTenantsTenantIdsettingsGeneralSettingsRouteImport.update({
    id: '/tenants/$tenantId/(settings)/general-settings',
    path: '/tenants/$tenantId/general-settings',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantsTenantIdsettingsEnrollmentSettingsRoute =
  DashboardTenantsTenantIdsettingsEnrollmentSettingsRouteImport.update({
    id: '/tenants/$tenantId/(settings)/enrollment-settings',
    path: '/tenants/$tenantId/enrollment-settings',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantsTenantIdsettingsDataSettingsRoute =
  DashboardTenantsTenantIdsettingsDataSettingsRouteImport.update({
    id: '/tenants/$tenantId/(settings)/data-settings',
    path: '/tenants/$tenantId/data-settings',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardTenantsTenantIdsettingsAuthSettingsRoute =
  DashboardTenantsTenantIdsettingsAuthSettingsRouteImport.update({
    id: '/tenants/$tenantId/(settings)/auth-settings',
    path: '/tenants/$tenantId/auth-settings',
    getParentRoute: () => DashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof authIndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/login-callback': typeof authLoginCallbackRoute
  '/wait': typeof authWaitRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/activities': typeof DashboardActivitiesIndexRoute
  '/dashboard/clients': typeof DashboardClientsIndexRoute
  '/dashboard/consents': typeof DashboardConsentsIndexRoute
  '/dashboard/organizations': typeof DashboardOrganizationsIndexRoute
  '/dashboard/payments': typeof DashboardPaymentsIndexRoute
  '/dashboard/pcm': typeof DashboardPcmIndexRoute
  '/dashboard/tenants': typeof DashboardTenantsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/clients/$tenantId/$clientId': typeof DashboardClientsTenantIdClientIdRoute
  '/dashboard/consents/$tenantId/$consentId': typeof DashboardConsentsTenantIdConsentIdRoute
  '/dashboard/payments/$tenantId/$paymentId': typeof DashboardPaymentsTenantIdPaymentIdRoute
  '/dashboard/tenants/new': typeof DashboardTenantsNewIndexRoute
  '/dashboard/tenants/$tenantId/auth-settings': typeof DashboardTenantsTenantIdsettingsAuthSettingsRoute
  '/dashboard/tenants/$tenantId/data-settings': typeof DashboardTenantsTenantIdsettingsDataSettingsRoute
  '/dashboard/tenants/$tenantId/enrollment-settings': typeof DashboardTenantsTenantIdsettingsEnrollmentSettingsRoute
  '/dashboard/tenants/$tenantId/general-settings': typeof DashboardTenantsTenantIdsettingsGeneralSettingsRoute
  '/dashboard/tenants/$tenantId/mobile-settings': typeof DashboardTenantsTenantIdsettingsMobileSettingsRoute
  '/dashboard/tenants/$tenantId/payment-settings': typeof DashboardTenantsTenantIdsettingsPaymentSettingsRoute
  '/dashboard/tenants/$tenantId/feature-flags': typeof DashboardTenantsTenantIdFeatureFlagsIndexRoute
  '/dashboard/tenants/$tenantId/internal-credentials': typeof DashboardTenantsTenantIdInternalCredentialsIndexRoute
}
export interface FileRoutesByTo {
  '/login-callback': typeof authLoginCallbackRoute
  '/wait': typeof authWaitRoute
  '/': typeof authIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/activities': typeof DashboardActivitiesIndexRoute
  '/dashboard/clients': typeof DashboardClientsIndexRoute
  '/dashboard/consents': typeof DashboardConsentsIndexRoute
  '/dashboard/organizations': typeof DashboardOrganizationsIndexRoute
  '/dashboard/payments': typeof DashboardPaymentsIndexRoute
  '/dashboard/pcm': typeof DashboardPcmIndexRoute
  '/dashboard/tenants': typeof DashboardTenantsIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/clients/$tenantId/$clientId': typeof DashboardClientsTenantIdClientIdRoute
  '/dashboard/consents/$tenantId/$consentId': typeof DashboardConsentsTenantIdConsentIdRoute
  '/dashboard/payments/$tenantId/$paymentId': typeof DashboardPaymentsTenantIdPaymentIdRoute
  '/dashboard/tenants/new': typeof DashboardTenantsNewIndexRoute
  '/dashboard/tenants/$tenantId/auth-settings': typeof DashboardTenantsTenantIdsettingsAuthSettingsRoute
  '/dashboard/tenants/$tenantId/data-settings': typeof DashboardTenantsTenantIdsettingsDataSettingsRoute
  '/dashboard/tenants/$tenantId/enrollment-settings': typeof DashboardTenantsTenantIdsettingsEnrollmentSettingsRoute
  '/dashboard/tenants/$tenantId/general-settings': typeof DashboardTenantsTenantIdsettingsGeneralSettingsRoute
  '/dashboard/tenants/$tenantId/mobile-settings': typeof DashboardTenantsTenantIdsettingsMobileSettingsRoute
  '/dashboard/tenants/$tenantId/payment-settings': typeof DashboardTenantsTenantIdsettingsPaymentSettingsRoute
  '/dashboard/tenants/$tenantId/feature-flags': typeof DashboardTenantsTenantIdFeatureFlagsIndexRoute
  '/dashboard/tenants/$tenantId/internal-credentials': typeof DashboardTenantsTenantIdInternalCredentialsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/(auth)/login-callback': typeof authLoginCallbackRoute
  '/(auth)/wait': typeof authWaitRoute
  '/(auth)/': typeof authIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/activities/': typeof DashboardActivitiesIndexRoute
  '/dashboard/clients/': typeof DashboardClientsIndexRoute
  '/dashboard/consents/': typeof DashboardConsentsIndexRoute
  '/dashboard/organizations/': typeof DashboardOrganizationsIndexRoute
  '/dashboard/payments/': typeof DashboardPaymentsIndexRoute
  '/dashboard/pcm/': typeof DashboardPcmIndexRoute
  '/dashboard/tenants/': typeof DashboardTenantsIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/clients/$tenantId/$clientId': typeof DashboardClientsTenantIdClientIdRoute
  '/dashboard/consents/$tenantId/$consentId': typeof DashboardConsentsTenantIdConsentIdRoute
  '/dashboard/payments/$tenantId/$paymentId': typeof DashboardPaymentsTenantIdPaymentIdRoute
  '/dashboard/tenants/new/': typeof DashboardTenantsNewIndexRoute
  '/dashboard/tenants/$tenantId/(settings)/auth-settings': typeof DashboardTenantsTenantIdsettingsAuthSettingsRoute
  '/dashboard/tenants/$tenantId/(settings)/data-settings': typeof DashboardTenantsTenantIdsettingsDataSettingsRoute
  '/dashboard/tenants/$tenantId/(settings)/enrollment-settings': typeof DashboardTenantsTenantIdsettingsEnrollmentSettingsRoute
  '/dashboard/tenants/$tenantId/(settings)/general-settings': typeof DashboardTenantsTenantIdsettingsGeneralSettingsRoute
  '/dashboard/tenants/$tenantId/(settings)/mobile-settings': typeof DashboardTenantsTenantIdsettingsMobileSettingsRoute
  '/dashboard/tenants/$tenantId/(settings)/payment-settings': typeof DashboardTenantsTenantIdsettingsPaymentSettingsRoute
  '/dashboard/tenants/$tenantId/feature-flags/': typeof DashboardTenantsTenantIdFeatureFlagsIndexRoute
  '/dashboard/tenants/$tenantId/internal-credentials/': typeof DashboardTenantsTenantIdInternalCredentialsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login-callback'
    | '/wait'
    | '/dashboard/'
    | '/dashboard/activities'
    | '/dashboard/clients'
    | '/dashboard/consents'
    | '/dashboard/organizations'
    | '/dashboard/payments'
    | '/dashboard/pcm'
    | '/dashboard/tenants'
    | '/dashboard/users'
    | '/dashboard/clients/$tenantId/$clientId'
    | '/dashboard/consents/$tenantId/$consentId'
    | '/dashboard/payments/$tenantId/$paymentId'
    | '/dashboard/tenants/new'
    | '/dashboard/tenants/$tenantId/auth-settings'
    | '/dashboard/tenants/$tenantId/data-settings'
    | '/dashboard/tenants/$tenantId/enrollment-settings'
    | '/dashboard/tenants/$tenantId/general-settings'
    | '/dashboard/tenants/$tenantId/mobile-settings'
    | '/dashboard/tenants/$tenantId/payment-settings'
    | '/dashboard/tenants/$tenantId/feature-flags'
    | '/dashboard/tenants/$tenantId/internal-credentials'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login-callback'
    | '/wait'
    | '/'
    | '/dashboard'
    | '/dashboard/activities'
    | '/dashboard/clients'
    | '/dashboard/consents'
    | '/dashboard/organizations'
    | '/dashboard/payments'
    | '/dashboard/pcm'
    | '/dashboard/tenants'
    | '/dashboard/users'
    | '/dashboard/clients/$tenantId/$clientId'
    | '/dashboard/consents/$tenantId/$consentId'
    | '/dashboard/payments/$tenantId/$paymentId'
    | '/dashboard/tenants/new'
    | '/dashboard/tenants/$tenantId/auth-settings'
    | '/dashboard/tenants/$tenantId/data-settings'
    | '/dashboard/tenants/$tenantId/enrollment-settings'
    | '/dashboard/tenants/$tenantId/general-settings'
    | '/dashboard/tenants/$tenantId/mobile-settings'
    | '/dashboard/tenants/$tenantId/payment-settings'
    | '/dashboard/tenants/$tenantId/feature-flags'
    | '/dashboard/tenants/$tenantId/internal-credentials'
  id:
    | '__root__'
    | '/(auth)'
    | '/dashboard'
    | '/(auth)/login-callback'
    | '/(auth)/wait'
    | '/(auth)/'
    | '/dashboard/'
    | '/dashboard/activities/'
    | '/dashboard/clients/'
    | '/dashboard/consents/'
    | '/dashboard/organizations/'
    | '/dashboard/payments/'
    | '/dashboard/pcm/'
    | '/dashboard/tenants/'
    | '/dashboard/users/'
    | '/dashboard/clients/$tenantId/$clientId'
    | '/dashboard/consents/$tenantId/$consentId'
    | '/dashboard/payments/$tenantId/$paymentId'
    | '/dashboard/tenants/new/'
    | '/dashboard/tenants/$tenantId/(settings)/auth-settings'
    | '/dashboard/tenants/$tenantId/(settings)/data-settings'
    | '/dashboard/tenants/$tenantId/(settings)/enrollment-settings'
    | '/dashboard/tenants/$tenantId/(settings)/general-settings'
    | '/dashboard/tenants/$tenantId/(settings)/mobile-settings'
    | '/dashboard/tenants/$tenantId/(settings)/payment-settings'
    | '/dashboard/tenants/$tenantId/feature-flags/'
    | '/dashboard/tenants/$tenantId/internal-credentials/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/(auth)/': {
      id: '/(auth)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authIndexRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/wait': {
      id: '/(auth)/wait'
      path: '/wait'
      fullPath: '/wait'
      preLoaderRoute: typeof authWaitRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/login-callback': {
      id: '/(auth)/login-callback'
      path: '/login-callback'
      fullPath: '/login-callback'
      preLoaderRoute: typeof authLoginCallbackRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/dashboard/users/': {
      id: '/dashboard/users/'
      path: '/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof DashboardUsersIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/': {
      id: '/dashboard/tenants/'
      path: '/tenants'
      fullPath: '/dashboard/tenants'
      preLoaderRoute: typeof DashboardTenantsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/pcm/': {
      id: '/dashboard/pcm/'
      path: '/pcm'
      fullPath: '/dashboard/pcm'
      preLoaderRoute: typeof DashboardPcmIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/payments/': {
      id: '/dashboard/payments/'
      path: '/payments'
      fullPath: '/dashboard/payments'
      preLoaderRoute: typeof DashboardPaymentsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/organizations/': {
      id: '/dashboard/organizations/'
      path: '/organizations'
      fullPath: '/dashboard/organizations'
      preLoaderRoute: typeof DashboardOrganizationsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/consents/': {
      id: '/dashboard/consents/'
      path: '/consents'
      fullPath: '/dashboard/consents'
      preLoaderRoute: typeof DashboardConsentsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/clients/': {
      id: '/dashboard/clients/'
      path: '/clients'
      fullPath: '/dashboard/clients'
      preLoaderRoute: typeof DashboardClientsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/activities/': {
      id: '/dashboard/activities/'
      path: '/activities'
      fullPath: '/dashboard/activities'
      preLoaderRoute: typeof DashboardActivitiesIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/new/': {
      id: '/dashboard/tenants/new/'
      path: '/tenants/new'
      fullPath: '/dashboard/tenants/new'
      preLoaderRoute: typeof DashboardTenantsNewIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/payments/$tenantId/$paymentId': {
      id: '/dashboard/payments/$tenantId/$paymentId'
      path: '/payments/$tenantId/$paymentId'
      fullPath: '/dashboard/payments/$tenantId/$paymentId'
      preLoaderRoute: typeof DashboardPaymentsTenantIdPaymentIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/consents/$tenantId/$consentId': {
      id: '/dashboard/consents/$tenantId/$consentId'
      path: '/consents/$tenantId/$consentId'
      fullPath: '/dashboard/consents/$tenantId/$consentId'
      preLoaderRoute: typeof DashboardConsentsTenantIdConsentIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/clients/$tenantId/$clientId': {
      id: '/dashboard/clients/$tenantId/$clientId'
      path: '/clients/$tenantId/$clientId'
      fullPath: '/dashboard/clients/$tenantId/$clientId'
      preLoaderRoute: typeof DashboardClientsTenantIdClientIdRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/$tenantId/internal-credentials/': {
      id: '/dashboard/tenants/$tenantId/internal-credentials/'
      path: '/tenants/$tenantId/internal-credentials'
      fullPath: '/dashboard/tenants/$tenantId/internal-credentials'
      preLoaderRoute: typeof DashboardTenantsTenantIdInternalCredentialsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/$tenantId/feature-flags/': {
      id: '/dashboard/tenants/$tenantId/feature-flags/'
      path: '/tenants/$tenantId/feature-flags'
      fullPath: '/dashboard/tenants/$tenantId/feature-flags'
      preLoaderRoute: typeof DashboardTenantsTenantIdFeatureFlagsIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/$tenantId/(settings)/payment-settings': {
      id: '/dashboard/tenants/$tenantId/(settings)/payment-settings'
      path: '/tenants/$tenantId/payment-settings'
      fullPath: '/dashboard/tenants/$tenantId/payment-settings'
      preLoaderRoute: typeof DashboardTenantsTenantIdsettingsPaymentSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/$tenantId/(settings)/mobile-settings': {
      id: '/dashboard/tenants/$tenantId/(settings)/mobile-settings'
      path: '/tenants/$tenantId/mobile-settings'
      fullPath: '/dashboard/tenants/$tenantId/mobile-settings'
      preLoaderRoute: typeof DashboardTenantsTenantIdsettingsMobileSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/$tenantId/(settings)/general-settings': {
      id: '/dashboard/tenants/$tenantId/(settings)/general-settings'
      path: '/tenants/$tenantId/general-settings'
      fullPath: '/dashboard/tenants/$tenantId/general-settings'
      preLoaderRoute: typeof DashboardTenantsTenantIdsettingsGeneralSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/$tenantId/(settings)/enrollment-settings': {
      id: '/dashboard/tenants/$tenantId/(settings)/enrollment-settings'
      path: '/tenants/$tenantId/enrollment-settings'
      fullPath: '/dashboard/tenants/$tenantId/enrollment-settings'
      preLoaderRoute: typeof DashboardTenantsTenantIdsettingsEnrollmentSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/$tenantId/(settings)/data-settings': {
      id: '/dashboard/tenants/$tenantId/(settings)/data-settings'
      path: '/tenants/$tenantId/data-settings'
      fullPath: '/dashboard/tenants/$tenantId/data-settings'
      preLoaderRoute: typeof DashboardTenantsTenantIdsettingsDataSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/tenants/$tenantId/(settings)/auth-settings': {
      id: '/dashboard/tenants/$tenantId/(settings)/auth-settings'
      path: '/tenants/$tenantId/auth-settings'
      fullPath: '/dashboard/tenants/$tenantId/auth-settings'
      preLoaderRoute: typeof DashboardTenantsTenantIdsettingsAuthSettingsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authLoginCallbackRoute: typeof authLoginCallbackRoute
  authWaitRoute: typeof authWaitRoute
  authIndexRoute: typeof authIndexRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authLoginCallbackRoute: authLoginCallbackRoute,
  authWaitRoute: authWaitRoute,
  authIndexRoute: authIndexRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface DashboardRouteRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardActivitiesIndexRoute: typeof DashboardActivitiesIndexRoute
  DashboardClientsIndexRoute: typeof DashboardClientsIndexRoute
  DashboardConsentsIndexRoute: typeof DashboardConsentsIndexRoute
  DashboardOrganizationsIndexRoute: typeof DashboardOrganizationsIndexRoute
  DashboardPaymentsIndexRoute: typeof DashboardPaymentsIndexRoute
  DashboardPcmIndexRoute: typeof DashboardPcmIndexRoute
  DashboardTenantsIndexRoute: typeof DashboardTenantsIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardClientsTenantIdClientIdRoute: typeof DashboardClientsTenantIdClientIdRoute
  DashboardConsentsTenantIdConsentIdRoute: typeof DashboardConsentsTenantIdConsentIdRoute
  DashboardPaymentsTenantIdPaymentIdRoute: typeof DashboardPaymentsTenantIdPaymentIdRoute
  DashboardTenantsNewIndexRoute: typeof DashboardTenantsNewIndexRoute
  DashboardTenantsTenantIdsettingsAuthSettingsRoute: typeof DashboardTenantsTenantIdsettingsAuthSettingsRoute
  DashboardTenantsTenantIdsettingsDataSettingsRoute: typeof DashboardTenantsTenantIdsettingsDataSettingsRoute
  DashboardTenantsTenantIdsettingsEnrollmentSettingsRoute: typeof DashboardTenantsTenantIdsettingsEnrollmentSettingsRoute
  DashboardTenantsTenantIdsettingsGeneralSettingsRoute: typeof DashboardTenantsTenantIdsettingsGeneralSettingsRoute
  DashboardTenantsTenantIdsettingsMobileSettingsRoute: typeof DashboardTenantsTenantIdsettingsMobileSettingsRoute
  DashboardTenantsTenantIdsettingsPaymentSettingsRoute: typeof DashboardTenantsTenantIdsettingsPaymentSettingsRoute
  DashboardTenantsTenantIdFeatureFlagsIndexRoute: typeof DashboardTenantsTenantIdFeatureFlagsIndexRoute
  DashboardTenantsTenantIdInternalCredentialsIndexRoute: typeof DashboardTenantsTenantIdInternalCredentialsIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardActivitiesIndexRoute: DashboardActivitiesIndexRoute,
  DashboardClientsIndexRoute: DashboardClientsIndexRoute,
  DashboardConsentsIndexRoute: DashboardConsentsIndexRoute,
  DashboardOrganizationsIndexRoute: DashboardOrganizationsIndexRoute,
  DashboardPaymentsIndexRoute: DashboardPaymentsIndexRoute,
  DashboardPcmIndexRoute: DashboardPcmIndexRoute,
  DashboardTenantsIndexRoute: DashboardTenantsIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardClientsTenantIdClientIdRoute: DashboardClientsTenantIdClientIdRoute,
  DashboardConsentsTenantIdConsentIdRoute:
    DashboardConsentsTenantIdConsentIdRoute,
  DashboardPaymentsTenantIdPaymentIdRoute:
    DashboardPaymentsTenantIdPaymentIdRoute,
  DashboardTenantsNewIndexRoute: DashboardTenantsNewIndexRoute,
  DashboardTenantsTenantIdsettingsAuthSettingsRoute:
    DashboardTenantsTenantIdsettingsAuthSettingsRoute,
  DashboardTenantsTenantIdsettingsDataSettingsRoute:
    DashboardTenantsTenantIdsettingsDataSettingsRoute,
  DashboardTenantsTenantIdsettingsEnrollmentSettingsRoute:
    DashboardTenantsTenantIdsettingsEnrollmentSettingsRoute,
  DashboardTenantsTenantIdsettingsGeneralSettingsRoute:
    DashboardTenantsTenantIdsettingsGeneralSettingsRoute,
  DashboardTenantsTenantIdsettingsMobileSettingsRoute:
    DashboardTenantsTenantIdsettingsMobileSettingsRoute,
  DashboardTenantsTenantIdsettingsPaymentSettingsRoute:
    DashboardTenantsTenantIdsettingsPaymentSettingsRoute,
  DashboardTenantsTenantIdFeatureFlagsIndexRoute:
    DashboardTenantsTenantIdFeatureFlagsIndexRoute,
  DashboardTenantsTenantIdInternalCredentialsIndexRoute:
    DashboardTenantsTenantIdInternalCredentialsIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
